export const SET_TURBINE_PROPERTIES = "SET_TURBINE_PROPERTIES";
export const SET_TURBINE_PROPERTIES_VALIDITY = "SET_TURBINE_PROPERTIES_VALIDITY";
export const SET_GEARBOX_VALIDITY = "SET_GEARBOX_VALIDITY";
export const SET_SHAFTS_VALIDITY = "SET_SHAFTS_VALIDITY";
export const SET_SHAFTS_BEARING_VALIDITY = "SET_SHAFTS_BEARING_VALIDITY";
export const SET_GEARS_VALIDITY = "SET_GEARS_VALIDITY";
export const SET_GEAR_MESH_FREQUENCIES_VALIDITY = "SET_GEAR_MESH_FREQUENCIES_VALIDITY";
export const SET_EFFECTIVE_SINCE_VALIDITY = "SET_EFFECTIVE_SINCE_VALIDITY";
export const SET_GEARBOX_MODEL = "SET_GEARBOX_MODEL";
export const SET_GEARBOX_STAGES = "SET_GEARBOX_STAGES";
export const ADD_GEARBOX_STAGE = "ADD_GEARBOX_STAGE";
export const REMOVE_GEARBOX_STAGE = "REMOVE_GEARBOX_STAGE";
export const SET_TURBINE_SHAFTS = "SET_TURBINE_SHAFTS";
export const ADD_TURBINE_SHAFTS = "ADD_TURBINE_SHAFTS";
export const ADD_SHAFT_BEARING = "ADD_SHAFT_BEARING";
export const REMOVE_TURBINE_SHAFTS = "REMOVE_TURBINE_SHAFTS";
export const ADD_GEAR = "ADD_GEAR";
export const REMOVE_GEAR = "REMOVE_GEAR";
export const SET_GEAR = "SET_GEAR";
export const SET_GEAR_MESH_FREQUENCY = "SET_GEAR_MESH_FREQUENCY";
export const ADD_GEAR_MESH_FREQUENCY = "ADD_GEAR_MESH_FREQUENCY";
export const REMOVE_GEAR_MESH_FREQUENCY = "REMOVE_GEAR_MESH_FREQUENCY";
export const GET_KINEMATIC_CONFIGURATION = "GET_KINEMATIC_CONFIGURATION";
export const CREATE_KINEMATIC_CONFIGURATION = "CREATE_KINEMATIC_CONFIGURATION";
export const SET_TURBINE_VERSIONS = "SET_TURBINE_VERSIONS";
export const DOWNLOAD_KINEMATIC_CONFIGURATION = "DOWNLOAD_KINEMATIC_CONFIGURATION";
export const SHOW_TOAST_MESSAGE = "SHOW_TOAST_MESSAGE";
export const ENABLE_FORMS = "ENABLE_FORMS";
export const SET_NEW_CONFIGURATION = "SET_NEW_CONFIGURATION";
